import { Flex, VStack, Input, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { EventsSummary } from '../../../events-summary';
import { ManageEventMergeStore } from '../../store/manage-merge-event-store';

interface ManageEventMergeManagerHeaderProps {
    store: ManageEventMergeStore;
}

export const ManageEventMergeManagerHeader: React.FC<ManageEventMergeManagerHeaderProps> = observer(
    ({ store }) => {
        return (
            <Flex direction="column" mb="1">
                <Text>Manage Event Merge</Text>
                <VStack spacing="2" align="left" mt="4">
                    <Text variant="bodyMd">
                        Merge events to combine multiple events into one. Unmerge events by
                        deselecting them below.
                    </Text>
                    <Flex width="60%" flexDirection="column" gap="1">
                        <Input
                            type="text"
                            isClearable
                            leftIcon="Search"
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                store?.updateSearch(e.currentTarget.value);
                            }}
                            role="textbox"
                        />
                        <Text color="placeholder" variant="bodyMd">
                            Search by Event Number, CFS, Location, D-Area or Narrative
                        </Text>
                    </Flex>
                    <VStack spacing="1" align="left">
                        <EventsSummary
                            label="Already Merged"
                            eventNumbers={
                                store
                                    ? store.initiallyMergedItems
                                          .slice()
                                          .sort(function (a, b) {
                                              return a.id === store.currentPrimaryEvent.event.id
                                                  ? -1
                                                  : b.id === store.currentPrimaryEvent.event.id
                                                  ? 1
                                                  : a.eventNumber.localeCompare(b.eventNumber);
                                          })
                                          .map((i) => i.eventNumber)
                                    : []
                            }
                            unselectedEventNumbers={
                                store ? store.getUnmergeItems().map((i) => i.eventNumber) : []
                            }
                        />
                        <EventsSummary
                            label="To Merge"
                            eventNumbers={
                                store
                                    ? store
                                          .getMergeItems()
                                          .sort(function (a, b) {
                                              return a.id === store.currentPrimaryEvent.event.id
                                                  ? -1
                                                  : b.id === store.currentPrimaryEvent.event.id
                                                  ? 1
                                                  : a.eventNumber.localeCompare(b.eventNumber);
                                          })
                                          .map((i) => i.eventNumber)
                                    : []
                            }
                        />
                    </VStack>
                </VStack>
            </Flex>
        );
    }
);
